import client from '@/clients/customer/api-client';

export const logOut = () => client.post('/logout');

export const accountDeleteRequest = () => client.delete('/profile');
